import React from 'react'
import './styles.scss'

import { ReactComponent as Atlassian } from '../../../images/demo-form/logos/atlassian.svg'
import { ReactComponent as IBM } from '../../../images/demo-form/logos/ibm.svg'
import { ReactComponent as Intuit } from '../../../images/demo-form/logos/intuit.svg'
import { ReactComponent as SAP } from '../../../images/demo-form/logos/sap.svg'
import { ReactComponent as NBC } from '../../../images/demo-form/logos/nbc.svg'
import { ReactComponent as Invision } from '../../../images/demo-form/logos/invision.svg'
import { ReactComponent as Meetup } from '../../../images/demo-form/logos/meetup.svg'
import { ReactComponent as Microsoft } from '../../../images/demo-form/logos/microsoft.svg'

const DemoFormLogos = () => (
  <div className="logo-row">
    <h3><span>Innovative Teams</span> Choose LaunchDarkly</h3>
    <div className="customer-logos">
      <div className="customer-logo-container">
        <Atlassian className="atlassian-logo" />
      </div>
      <div className="customer-logo-container">
        <IBM className="ibm-loog" />
      </div>
      <div className="customer-logo-container">
        <Invision className="invision-logo" />
      </div>
      <div className="customer-logo-container hidden-mobile">
        <SAP className="sap-logo" />
      </div>
      <div className="customer-logo-container">
        <Microsoft className="microsoft-logo" />
      </div>
      <div className="customer-logo-container">
        <Intuit className="intuit-logo" />
      </div>
      <div className="customer-logo-container">
        <NBC className="nbc-logo" />
      </div>
      <div className="customer-logo-container hidden-mobile">
        <Meetup className="meetup-logo" />
      </div>
    </div>
  </div>
)

export default DemoFormLogos
